import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';
import { tokens } from '@hotjar/hotsauce';
import { UpsellPopover } from '@hotjar/upsell';
import { upsell } from '@hotjar/webapp/domains/revenue/upsell';
import { useSelector } from '@hotjar/recordings/src/store/player/context';
import type { Site } from '@hotjar/site';

import { Tile } from './Tile';

// @FIXME: Hacky way to get the triangle on top of the upsell popover.
const StyledUpsellPopover = styled(UpsellPopover)`
  &::after {
    content: '◤';
    color: white;
    position: fixed;
    top: -9px;
    right: 20%;
    // Middle color from tokens.elevation(3);
    text-shadow: -1px -1px 3px rgb(16 16 16 / 10%);
    transform: rotate(45deg);
  }
`;

const UPSELL_REFERRER = 'recordings.session_info.error_widget.empty';

export const UpsellErrorTile = (): JSX.Element => {
  const { t } = useTranslation('common');

  // eslint-disable-next-line @typescript-eslint/no-shadow
  const { site } = useSelector(({ site }) => ({ site }));

  return (
    <StyledUpsellPopover
      title={t('player.side-panel.user-actions.error-upsell-title')}
      text={t('player.side-panel.user-actions.error-upsell-description')}
      upgradeMessage={t('player.side-panel.user-actions.error-upsell-description')}
      handleUpgradeClick={() => {
        upsell({
          site: site as Site,
          referrer: UPSELL_REFERRER,
        });
      }}
      placement="bottom-end"
      trigger="mouseenter focus"
    >
      <div>
        <Tile
          icon="error"
          color={tokens.color.neutral_200}
          value={null}
          title={t('player.side-panel.user-actions.errors')}
        />
      </div>
    </StyledUpsellPopover>
  );
};
